import React, { useContext, useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

import "../../src/Styles/artist.css";
import NavBar from "../components/NavBar";
import Footer from "../components/Footer";
import { ArtistContext } from "../Contexts/ArtistContext";
import Loading from "./Loading";
import { Helmet } from "react-helmet-async";
import ReactGA from "react-ga";


const Artist = () => {
  const { artists, fetchArtists, loading } = useContext(ArtistContext);
  useEffect(() => {
    Aos.init({ duration: 100 });
    fetchArtists();
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);
  return (
    <div className="everything">
      <Helmet>
        <title>SAWA | Artists</title>
        <meta name="description" content="" />
        <link rel="canonical" href="/about-artists" />
      </Helmet>
      <NavBar />
      <div className="topArtist" data-aos="fade-up" data-aos-duration="2000">
        <h2>Meet Our Artists</h2>
        {/* <p>
          Lorem ipsum dolor sit amet consectetur. Commodo vulputate malesuada
          lectus phasellus at turpis ac. Aenean etiam in volutpat risus eu metus
          eros turpis. Quis sit nulla augue velit. Lorem ipsum dolor sit amet
          consectetur. Commodo vulputate malesuada lectus phasellus at turpis
          ac. Aenean etiam in volutpat risus eu metus eros turpis. Quis sit
          nulla augue velit.
        </p> */}
      </div>
      {loading ? (
        <Loading /> // Display the Loading component while loading is true
      ) : (
        <div className="Cards">
          {artists.map((artist, index) => (
            <div
              className="artist"
              key={artist._id}
              data-aos="fade-left"
              data-aos-duration="500"
              data-aos-delay={index * 500}>
              <a href={`/artistDetails/${artist._id}`}>
                <img
                  src={`${artist.image}`}
                  alt={`${artist.name} profile`}
                />
                <h2>{artist.name}</h2>
                {/* <p>{artist.description}</p> */}
              </a>
            </div>
          ))}
        </div>
      )}
      ;
      <Footer />
    </div>
  );
};
export default Artist;
